import React from "react";
import { GeneralMessage, useGeneralMessage } from "../../../common/APICommon";
import { LoadingSpinner } from "../../../common/Loading";
import { useMaintenanceSalaryCombinationCode } from "../../hooks/useMaintenanceSalaryCombinationCode";
import MaintenanceSalaryCombinationCodeModule from "../../components/modules/MaintenanceSalaryCombinationCode/MaintenanceSalaryCombinationCodeModule";

const MaintenanceSalaryCombinationCodePage = ({ user, isHideSideMenu }) => {
  const { showGeneralMessage, showMessage, message, isSuccess } = useGeneralMessage();
  const methods = useMaintenanceSalaryCombinationCode({ showGeneralMessage });

  return (
    <>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="MainteInfo shadow-xl bg-white rounded-lg">
            <div className="mainteHeader p-4 border-b">
              <div className='sub-title row text-sm'>
                <span className="text-gray-400">{"Maintenance > "}</span>
                <span className="border-b border-black">{"Salary Combination Codes"}</span>
              </div>
              <h3 className="text-xl font-bold mt-2">Maintenance Salary Combination Codes</h3>
            </div>
            <MaintenanceSalaryCombinationCodeModule user={user} {...methods} />
          </div>
        </div>
      </div>
      
      <GeneralMessage form={showMessage} message={message} isSuccess={isSuccess} />
      <LoadingSpinner loading={methods.loading} />
    </>
  );
};

export default MaintenanceSalaryCombinationCodePage;